import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-555aa79f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questionnaire-fill-out-step" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, [
  /*#__PURE__*/_createTextVNode(" 以下の内容に間違いがないかご確認の上"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 「登録する」ボタンを押してください ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "お名前 [必須]", -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "メールアドレス [必須]", -1))
const _hoisted_6 = { class: "content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "電話番号 [必須]", -1))
const _hoisted_8 = { class: "content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "生年月日 [必須]", -1))
const _hoisted_10 = { class: "content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "都道府県 [必須]", -1))
const _hoisted_12 = { class: "content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "性別 [必須]", -1))
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "container-buttons" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 登録する ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 修正する ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButtonPrimary = _resolveComponent("AppButtonPrimary")!
  const _component_AppButtonSecondary = _resolveComponent("AppButtonSecondary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.questionnaire.name), 1),
    _hoisted_5,
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.questionnaire.email), 1),
    _hoisted_7,
    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.questionnaire.phoneNumber), 1),
    _hoisted_9,
    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.questionnaire.birthday), 1),
    _hoisted_11,
    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.prefectureName), 1),
    _hoisted_13,
    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.genderName), 1),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_AppButtonPrimary, { onButton: _ctx.next }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      }, 8, ["onButton"]),
      _createVNode(_component_AppButtonSecondary, { onButton: _ctx.previous }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }, 8, ["onButton"])
    ])
  ]))
}